<template>
  <div class="no">

    <img src="../../assets/State/no.png" alt="">
    <p>
      哎呀，网络已走丢<br/>
      您可以尝试<span @click="link">刷新数据</span>
    </p>

  </div>
</template>

<script>
export default {
  name: "NoNetwork",
  data() {
    return{

    }
  },
  created() {

  },
  methods: {
    link() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="less" scoped>
.no{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.75rem;
  img{
    width: 90%;
  }
  p{
    font-size: 0.8125rem;
    text-align: center;
    color: #808080;
    span{
      color: #3B9CFD;
    }
  }
}
</style>
